import { writable } from "svelte/store";

export type Address = {
  id?: number;
  label?: string;
  address1: string;
  zip: string;
  city: string;
  state: string;
  country: string;
  latitude: number;
  longitude: number;
  place_id: string;
  address2?: string;
  note?: string;
  formattedAddress?: string;
};
export type PersistedAddress = Address & { is_default?: boolean, id: number };

export const initStore = () => writable<PersistedAddress>();
export const addressStore = initStore();
export const set = (address: PersistedAddress) => addressStore.set(address);
